export default __webpack_public_path__ + "static/media/woman-touching-screen.221ba490.jpg";